export function getSurveys (state){
  return state.surveys
}